// extracted by mini-css-extract-plugin
module.exports = {"numberCircle":"Background_numberCircle__3R9ri","ai":"Background_ai__aQ4Li"};